export default (props, vars) =>
  vars?.['defaultbox145']?.['item']?.['status'] !== 'LOCKED' &&
  !vars?.['defaultbox145']?.['item']?.['empty'];
